/* =====================================================================
   TJC Alien Takeover – glitch sale effects
   Loaded when Theme settings → "Alien Takeover sale" is ticked, and always
   on the UFO product template (html.at-ufo-page, set in theme.liquid).
   Does nothing if html.alien-takeover is missing or the visitor prefers
   reduced motion. Removing the class live switches everything off.
   ===================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var isOn = function () { return root.classList.contains('alien-takeover'); };
  if (!isOn()) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var swapMQ = window.matchMedia('(min-width: 768px) and (hover: hover)'); // theme's second-image hover rule

  var body = document.body;
  var pageType = (body.className.match(/(\S+)-template/) || [])[1] || '';
  var CARD_PAGES = ['index', 'collection', 'search', 'list-collections'];
  // UFO product template (product.ufo.json): always on, gets the homepage set of effects + the ship
  var ufoPage = root.classList.contains('at-ufo-page');
  var onCardPage = ufoPage || CARD_PAGES.indexOf(pageType) !== -1;
  var onHome = ufoPage || pageType === 'index';

  /* Never touch the buy path. */
  var BUY_PATH = 'product-form, form[action*="/cart"], .product-card__actions, .product-card__quickview, ' +
    'quick-view-modal, cart-drawer, sticky-atc-bar, .product__info-wrapper, .main-product, [data-section-type="main-product"]';
  var inBuyPath = function (el) { return !!(el && el.closest && el.closest(BUY_PATH)); };

  var SYMS = '#%&@$*?!/<>+=~^|';
  var rs = function () { return SYMS[(Math.random() * SYMS.length) | 0]; };

  var inView = function (el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
  };

  /* Deepest element that holds exactly this text and nothing but text. */
  function textLeaf(el) {
    var want = el.textContent.trim();
    if (!want) return null;
    var node = el;
    for (;;) {
      var kids = Array.prototype.filter.call(node.childNodes, function (n) {
        return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
      });
      if (kids.length === 1 && kids[0].nodeType === 1 && kids[0].textContent.trim() === want) { node = kids[0]; continue; }
      if (kids.every(function (n) { return n.nodeType === 3; })) return node;
      return null; // mixed markup (italics, links, line breaks): leave it alone
    }
  }

  /* Plain decode used by prices and the ticker; width frozen so nothing shifts. */
  function scramble(el, final, ms) {
    if (el._scr) return;
    el._scr = true;
    var w = el.getBoundingClientRect().width;
    var prevW = el.style.width, prevD = el.style.display, prevWS = el.style.whiteSpace;
    if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
    el.style.width = w + 'px';
    el.style.whiteSpace = 'nowrap';
    var chars = Array.from(final), t0 = performance.now(), lt = 0;
    (function f(now) {
      var p = Math.min((now - t0) / ms, 1);
      if (now - lt > 45 || p >= 1) {
        lt = now;
        el.textContent = chars.map(function (c, i) {
          return c === ' ' || i < p * chars.length ? c : rs();
        }).join('');
      }
      if (p < 1 && isOn()) requestAnimationFrame(f);
      else {
        el.textContent = final;
        el.style.width = prevW; el.style.display = prevD; el.style.whiteSpace = prevWS;
        el._scr = false;
      }
    })(t0);
  }

  /* ---------------- 4A. Button text bars ---------------- */
  /* Wraps an element's plain text in <span class="glitch">; the element itself keeps its own styling. */
  function wrapGlitch(el) {
    if (el._at || el.children.length) return false;
    var text = el.textContent.trim();
    if (!text) return false;
    el._at = true;
    var span = document.createElement('span');
    span.className = 'glitch';
    span.dataset.atText = text;
    span.textContent = text;
    el.textContent = '';
    el.appendChild(span);
    return true;
  }
  /* Wraps just the first piece of text in an element that also holds an icon (e.g. menu label + chevron). */
  function wrapGlitchText(el) {
    if (el._at) return false;
    var node = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
    if (!node) return false;
    el._at = true;
    var text = node.textContent.trim();
    var span = document.createElement('span');
    span.className = 'glitch';
    span.dataset.atText = text;
    span.textContent = text;
    node.parentNode.replaceChild(span, node);
    return true;
  }
  /* Top-level header menu items (sitewide, like the ticker) */
  function initMenu(scope) {
    $$('.header__menu .menu__item > .reversed-link', scope).forEach(wrapGlitchText);
  }
  function initButtons(scope) {
    if (!onCardPage) return;
    // Section buttons ("Shop now" etc.) – these also get the small hover jitter
    $$('main .btn', scope).forEach(function (btn) {
      if (inBuyPath(btn) || btn.closest('.product-card')) return;
      if (wrapGlitch(btn)) btn.classList.add('at-btn');
    });
    // Tab titles (e.g. Beef Jerky / Biltong / Snap Sticks on the homepage)
    $$('main .tabs__tab-name', scope).forEach(wrapGlitch);
    // Product card button label ("Choose options" / "Add to cart"): text bars only, no jitter
    $$('.product-card .product-card__action-text', scope).forEach(function (t) {
      if (!t.closest('quick-view-modal')) wrapGlitch(t);
    });
  }

  /* ---------------- 4B. Heading symbol glitch (homepage) ---------------- */
  var HEAD_SEL = '.slideshow__title, .slideshow__subtitle, .section__heading, .section__subheading, ' +
    '.rich-text__heading, .rich-text__subheading';
  var heads = [];

  function build(leaf) {
    var text = leaf.textContent.trim().replace(/\s+/g, ' ');
    var g = document.createElement('span');
    g.className = 'glitch sym';
    g.dataset.atText = text;
    g._ch = [];
    var sr = document.createElement('span'); sr.className = 'at-sr'; sr.textContent = text; g.appendChild(sr);
    var vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true'); g.appendChild(vis);
    text.split(' ').forEach(function (w, wi, arr) {
      var wd = document.createElement('span'); wd.className = 'wd';
      Array.from(w).forEach(function (c) {
        var s = document.createElement('span'); s.className = 'ch'; s.textContent = c; s.dataset.c = c;
        wd.appendChild(s); g._ch.push(s);
      });
      vis.appendChild(wd);
      if (wi < arr.length - 1) vis.appendChild(document.createTextNode(' '));
    });
    leaf.textContent = '';
    leaf.appendChild(g);
    return g;
  }
  function restore(el) { el._ch.forEach(function (s) { s.textContent = s.dataset.c; s.classList.remove('sg'); }); }
  function lock(el) {
    if (el._busy) return;
    el.classList.remove('locked');
    el._ch.forEach(function (s) { s.style.width = ''; s.textContent = s.dataset.c; s.classList.remove('sg'); });
    var w = el._ch.map(function (s) { return s.getBoundingClientRect().width; });
    if (!w.some(function (x) { return x > 0; })) { el._locked = false; return; } // hidden: try again later
    el._ch.forEach(function (s, i) { s.style.width = w[i] + 'px'; });
    el.classList.add('locked');
    el._locked = true;
  }
  function symScramble(el, ms) {
    if (!isOn() || el._busy) return;
    if (!el._locked) lock(el);
    el._busy = true;
    var n = el._ch.length, t0 = performance.now(), lt = 0;
    (function f(now) {
      var p = Math.min((now - t0) / ms, 1);
      if (now - lt > 55 || p >= 1) {
        lt = now;
        el._ch.forEach(function (s, i) {
          var done = p >= 0.2 + 0.8 * (i / n);
          s.textContent = done ? s.dataset.c : rs();
          s.classList.toggle('sg', !done);
        });
      }
      if (p < 1 && isOn()) requestAnimationFrame(f);
      else { el._busy = false; restore(el); }
    })(t0);
  }
  function glitchLetter(el) {
    var s = el._ch[(Math.random() * el._ch.length) | 0], k = 0;
    if (!s || s.dataset.c === ' ') return;
    (function flip() {
      if (!el._hov) { restore(el); return; }
      if (k++ < 3) { s.textContent = rs(); s.classList.add('sg'); setTimeout(flip, 45); }
      else { s.textContent = s.dataset.c; s.classList.remove('sg'); }
    })();
  }

  var headIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { symScramble(e.target, 800); headIO.unobserve(e.target); }
    });
  }, { threshold: 0.8 }) : null;

  function initHeadings(scope) {
    if (!onHome) return;
    $$(HEAD_SEL, scope).forEach(function (h) {
      if (h._at || inBuyPath(h) || h.closest('.product-card')) return;
      h._at = true;
      var leaf = textLeaf(h);
      if (!leaf) return;
      var len = leaf.textContent.trim().length;
      if (len < 2 || len > 140) return;
      if (getComputedStyle(leaf).textTransform === 'capitalize') return; // per-letter slots would capitalise every letter
      var el = build(leaf);
      heads.push(el);
      el.addEventListener('mouseenter', function () {
        if (!isOn() || el._hov) return;
        el._hov = true;
        if (!el._locked) lock(el);
        (function step() {
          if (!el._hov) return;
          if (!el._busy) glitchLetter(el);
          el._t = setTimeout(step, 900 + Math.random() * 1700); // 0.9–2.6 s
        })();
      });
      el.addEventListener('mouseleave', function () {
        el._hov = false; clearTimeout(el._t);
        if (!el._busy) restore(el);
      });
      var slide = el.closest('.swiper-slide');
      if (slide) watchSlide(slide);
      else if (headIO) headIO.observe(el);
    });
    relock();
  }
  function relock() { heads.forEach(lock); }

  /* Hero slideshow: scramble subtitle then title whenever a slide becomes active. */
  function heroScramble(slide) {
    var list = $$('.sym', slide);
    list.forEach(function (el, i) {
      var isTitle = !!el.closest('.slideshow__title');
      setTimeout(function () { symScramble(el, isTitle ? 1100 : 900); }, 400 + i * 250);
    });
  }
  function watchSlide(slide) {
    if (slide._atWatch) return;
    slide._atWatch = true;
    var wasActive = slide.classList.contains('swiper-slide-active');
    if (wasActive) heroScramble(slide);
    new MutationObserver(function () {
      var active = slide.classList.contains('swiper-slide-active');
      if (active && !wasActive) heroScramble(slide);
      wasActive = active;
    }).observe(slide, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------------- 4C/4D. Product cards ---------------- */
  function cardImg(card) {
    if (card._atImg !== undefined) return card._atImg;
    // Custom ship targets (e.g. the UFO landing page hero): beam only, no glitch bars or static.
    // The section owns the element; [data-at-img] is where the beam lands.
    if (card.hasAttribute('data-at-target')) {
      card._atImg = card.querySelector('[data-at-img]') || card;
      return card._atImg;
    }
    var wrap = card.querySelector('.product-card__image-wrapper > a > motion-element') ||
               card.querySelector('.product-card__image-wrapper > a');
    var img = wrap && wrap.querySelector('.product-card__image--main img');
    if (!wrap || !img) { card._atImg = null; return null; }
    card.classList.add('at-card');
    wrap.classList.add('at-img');
    initButtons(card);
    var noise = document.createElement('i');
    noise.className = 'at-noise';
    noise.setAttribute('aria-hidden', 'true');
    wrap.appendChild(noise);
    img.addEventListener('load', function () { setSrc(card); });
    card._atImg = wrap;
    setSrc(card);
    return wrap;
  }
  function setSrc(card) {
    var wrap = card._atImg;
    if (!wrap) return;
    var img = card.querySelector('.product-card__image--main img');
    var second = card.querySelector('.product-card__image--second img');
    if (second && card.classList.contains('at-hov') && swapMQ.matches) img = second;
    var src = img && (img.currentSrc || img.src);
    if (src) wrap.style.setProperty('--at-src', 'url("' + src.replace(/"/g, '%22') + '")');
  }
  function cardPrice(card) {
    var fp = card.querySelector('.product-card__info .f-price');
    if (!fp) return null;
    var el = fp.classList.contains('f-price--on-sale')
      ? fp.querySelector('.f-price__sale .f-price-item--sale')
      : fp.querySelector('.f-price__regular .f-price-item--regular:last-of-type');
    if (!el || el.children.length || !el.textContent.trim()) return null;
    return el;
  }
  function priceScramble(card) {
    var el = cardPrice(card);
    if (!el || el._scr) return;
    el.dataset.atP = el.textContent.trim();
    scramble(el, el.dataset.atP, 450);
  }

  /* ---------------- 4G. The UFO ---------------- */
  /* Photo ship (assets/alien-ufo.webp) on a spring, so it floats, overshoots a little and settles.
     It banks into turns, pitches when climbing or diving, and bobs and sways while idle. */
  var SHIP_SRC = (document.currentScript && document.currentScript.getAttribute('data-ship')) || '';
  var ufo, beam, ship, card = null, prevCard = null, mouse = null, touchTimer = null;
  var SW = 130;                       // ship width in px
  var BELLY = Math.round(SW * 0.33);  // where the beam leaves the hull (image is 0.366 × width tall)
  var SPRING = 0.018, DAMP = 0.85;    // ≈ same pace as the approved follow, with ~8% overshoot
  var pos = { x: -220, y: -100 }, vel = { x: 0, y: 0 }, rot = { z: 0, x: 0, y: 0 };
  var bh = 0, bw = 0, last = performance.now();
  var shipEnabled = onCardPage && root.getAttribute('data-at-ship') !== 'off'; // Theme settings → "Show the UFO"
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  var SVG_SHIP = '<svg class="at-ship" viewBox="0 0 120 60" focusable="false">' +
    '<ellipse cx="60" cy="22" rx="20" ry="16" fill="var(--at-c3)" fill-opacity=".35" stroke="var(--at-c3)" stroke-width="1.5"/>' +
    '<ellipse cx="60" cy="34" rx="56" ry="14" fill="#10172b" stroke="var(--at-c1)" stroke-width="2"/></svg>';

  function makeShip() {
    ufo = document.createElement('div');
    ufo.id = 'at-ufo';
    ufo.setAttribute('aria-hidden', 'true');
    ufo.style.width = SW + 'px';
    ufo.innerHTML = '<div id="at-beam"></div>' +
      (SHIP_SRC ? '<img class="at-ship" alt="" src="' + SHIP_SRC + '" width="' + SW + '" height="' + Math.round(SW * 0.366) + '" decoding="async">' : SVG_SHIP);
    body.appendChild(ufo);
    beam = ufo.querySelector('#at-beam');
    beam.style.top = BELLY + 'px';
    ship = ufo.querySelector('.at-ship');
    if (ship.tagName === 'IMG') ship.addEventListener('error', function () { // image missing → drawn ship
      ship.insertAdjacentHTML('afterend', SVG_SHIP); var old = ship; ship = old.nextElementSibling; old.remove();
    });
    if (!canHover) ufo.style.opacity = 0;
    requestAnimationFrame(tick);
  }
  function typing() {
    var a = document.activeElement;
    return !!(a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || a.isContentEditable));
  }
  function goal() {
    if (card && card.isConnected) {
      var r = card.getBoundingClientRect();
      return { x: r.left + r.width / 2 - SW / 2, y: r.top - 70, r: r };
    }
    if (canHover && mouse) return { x: mouse.x + 30, y: mouse.y - 70 };
    return { x: -260, y: pos.y };
  }
  function tick(now) {
    requestAnimationFrame(tick);
    var dt = Math.min((now - last) / 1000, 0.1); last = now;
    if (!isOn()) { ufo.style.display = 'none'; return; }
    ufo.style.display = '';
    if (canHover) ufo.style.opacity = typing() ? 0 : 1;
    else ufo.style.opacity = card ? 1 : 0;

    var g = goal();
    // Spring, stepped at a fixed 60 Hz so it feels the same on 60/120/144 Hz screens
    var steps = clamp(Math.round(dt * 60), 1, 6);
    for (var i = 0; i < steps; i++) {
      vel.x = (vel.x + (g.x - pos.x) * SPRING) * DAMP;
      vel.y = (vel.y + (g.y - pos.y) * SPRING) * DAMP;
      pos.x += vel.x; pos.y += vel.y;
    }
    var dx = g.x - pos.x, dy = g.y - pos.y;

    // Attitude: bank into horizontal motion, pitch with vertical motion, plus an idle wobble
    var t = now / 1000;
    var wantZ = clamp(vel.x * 1.6, -16, 16) + Math.sin(t * 0.9) * 2;
    var wantX = clamp(-vel.y * 1.4, -20, 20) + Math.sin(t * 1.4) * 5;
    var wantY = clamp(vel.x * 0.9, -14, 14);
    var e = Math.min(0.15 * dt * 60, 0.6);
    rot.z += (wantZ - rot.z) * e; rot.x += (wantX - rot.x) * e; rot.y += (wantY - rot.y) * e;
    var bob = Math.sin(t * 1.7) * 3;

    var wantH = 0, wantW = 70, arrived = false;
    if (g.r) {
      arrived = Math.hypot(dx, dy) < 40;
      var wrap = card._atImg;
      if (arrived && wrap) {
        var ir = wrap.getBoundingClientRect(); // beam ends at the middle of the image
        wantH = Math.max(0, ir.top + ir.height / 2 - (pos.y + bob + BELLY));
        wantW = ir.width * 0.8;
      }
    }
    if (card !== prevCard) { if (prevCard) prevCard.classList.remove('lifting'); prevCard = card; }
    if (card) card.classList.toggle('lifting', arrived);
    bh += (wantH - bh) * 0.22; bw += (wantW - bw) * 0.22;

    ufo.style.transform = 'translate3d(' + pos.x.toFixed(2) + 'px,' + (pos.y + bob).toFixed(2) + 'px,0)';
    ship.style.transform = 'rotateZ(' + rot.z.toFixed(2) + 'deg) rotateX(' + rot.x.toFixed(2) + 'deg) rotateY(' + rot.y.toFixed(2) + 'deg)';
    beam.style.height = Math.max(0, bh) + 'px';
    beam.style.width = bw + 'px';
  }

  /* Card hover / tap via delegation, so cards added later (filters, sliders, infinite scroll) just work. */
  var hovCard = null;
  function cardFrom(t) {
    // The card's own button keeps the card active; the quick-view modal (rendered inside the card) does not.
    if (!t || !t.closest || t.closest('quick-view-modal')) return null;
    var c = t.closest('.product-card, [data-at-target]');
    return c && cardImg(c) ? c : null;
  }
  // A target mid-abduction (class set by the section) keeps the ship until the page changes.
  var held = function () { return !!(card && card.classList.contains('at-abducting')); };
  function setHover(c) {
    if (c === hovCard || held()) return;
    if (hovCard) { hovCard.classList.remove('at-hov'); setSrc(hovCard); }
    hovCard = c;
    if (shipEnabled) card = c;
    if (c && isOn()) {
      c.classList.add('at-hov');
      setSrc(c);
      setTimeout(function () { setSrc(c); }, 120);
      priceScramble(c);
    }
  }

  if (onCardPage) {
    if (canHover) {
      document.addEventListener('mouseover', function (e) { setHover(cardFrom(e.target)); }, { passive: true });
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget) setHover(null); });
      addEventListener('mousemove', function (e) { mouse = { x: e.clientX, y: e.clientY }; }, { passive: true });
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || !isOn() || !shipEnabled) return;
      var c = cardFrom(e.target);
      if (!c || held()) return;
      var fresh = card !== c;
      card = c; clearTimeout(touchTimer);
      var r = c.getBoundingClientRect();
      if (fresh) {
        // Cards: appear in place. Custom targets: a short swoop down from above.
        pos.x = r.left + r.width / 2 - SW / 2; pos.y = r.top - (c.hasAttribute('data-at-target') ? 190 : 70); vel.x = vel.y = 0;
      }
      touchTimer = setTimeout(function () { if (card === c && !held()) card = null; }, 2600);
    }, { passive: true });
    if (shipEnabled) makeShip();
  }

  /* ---------------- 4E. Header ticker decode ---------------- */
  setInterval(function () {
    if (!isOn() || document.hidden) return;
    var items = $$('.shopify-section-group-header-group .promotion__text').filter(function (el) {
      return !el.children.length && el.textContent.trim() && inView(el);
    });
    var el = items[(Math.random() * items.length) | 0];
    if (!el) return;
    if (!el.dataset.atP) el.dataset.atP = el.textContent.trim();
    scramble(el, el.dataset.atP, 900);
  }, 6000);

  /* ---------------- 4F. Ambient pulses ---------------- */
  function pulse(el, ms) { el.classList.add('go'); setTimeout(function () { el.classList.remove('go'); }, ms); }
  setInterval(function () {
    if (!isOn() || document.hidden) return;
    var picks = $$('.glitch:not(.go)').filter(function (el) {
      return !el._busy && inView(el) && !el.closest('.product-card__actions'); // card buttons are hidden until hover
    });
    if (onCardPage) {
      $$('.product-card').forEach(function (c) {
        if (inView(c) && !inBuyPath(c)) { var w = cardImg(c); if (w && !w.classList.contains('go')) picks.push(w); }
      });
    }
    var el = picks[(Math.random() * picks.length) | 0];
    if (el) pulse(el, 350 + Math.random() * 300);
  }, 2600);

  /* ---------------- 4H. Countdown corruption ---------------- */
  setInterval(function () {
    if (!isOn() || document.hidden || Math.random() > 0.04) return;
    var units = $$('.countdown-timer [data-timer-day], .countdown-timer [data-timer-hour], .countdown-timer [data-timer-minute], .countdown-timer [data-timer-second]')
      .filter(inView);
    var u = units[(Math.random() * units.length) | 0];
    if (!u) return;
    var real = u.textContent, i = (Math.random() * real.length) | 0;
    var bad = real.slice(0, i) + rs() + real.slice(i + 1);
    u.textContent = bad;
    setTimeout(function () { if (u.textContent === bad) u.textContent = real; }, 150);
  }, 1000);

  /* ---------------- Start-up ---------------- */
  function initAll(scope) { initMenu(scope); initButtons(scope); initHeadings(scope); }
  initAll(document);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(relock);
  var rz;
  addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(relock, 150); });
  // Theme editor: re-initialise sections when they are re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
